export default "__VITE_ASSET__dcd51fae__"